/**
 * Normalise un texte pour la recherche : minuscules, suppression des accents
 * (diacritiques) et espaces superflus. Permet une recherche insensible aux
 * accents ("ecole" trouve "école", "Tieoule" trouve "Tiéoulé").
 */
export function normalizeText(value: unknown): string {
  return (value ?? '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}
